import React from 'react';
import { CheckCircle, AlertCircle } from 'lucide-react';

interface AlertProps {
  type: 'success' | 'error';
  message: string | null;
}

export const Alert: React.FC<AlertProps> = ({ type, message }) => {
  if (!message) return null;
  
  return (
    <div className={`batch-alert ${type}`}>
      {type === 'success' ? <CheckCircle size={18} /> : <AlertCircle size={18} />}
      <span>{message}</span>
    </div>
  );
};
